import { toast } from 'sonner';

export const INITIAL_FORM_STATE = {
  first_name: '', last_name: '', email: '',
  country: '',
  phone_country_code: '', phone_number: '',
  occupation: '', linkedin_profile: '',
  investment_experience: '', investment_count: '',
  portfolio_value: '', investment_types: [],
  annual_income: '', net_worth: '',
  introduced_by: null, introducer_type: 'public',
  introducer_id: null, relationship: null
};

export const validateAccessForm = (formData) => {
  if (!formData.first_name.trim()) { toast.error('Please enter your first name'); return false; }
  if (!formData.last_name.trim()) { toast.error('Please enter your last name'); return false; }
  if (!formData.email.trim()) { toast.error('Please enter your email address'); return false; }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) { toast.error('Please enter a valid email address'); return false; }
  if (!formData.country) { toast.error('Please select your country'); return false; }
  if (!formData.investment_experience) { toast.error('Please select your investment experience'); return false; }
  if (!formData.investment_count) { toast.error('Please select your investment count'); return false; }
  return true;
};
